 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"common":"common","default~dashboard-dashboard-module~home-home-module~pages-print-bordero-print-bordero-module":"default~dashboard-dashboard-module~home-home-module~pages-print-bordero-print-bordero-module","dashboard-dashboard-module":"dashboard-dashboard-module","home-home-module":"home-home-module","default~pages-couriers-pages-deliveries-deliveries-module~pages-couriers-pages-validate-delivery-val~e6285bd4":"default~pages-couriers-pages-deliveries-deliveries-module~pages-couriers-pages-validate-delivery-val~e6285bd4","pages-print-bordero-print-bordero-module":"pages-print-bordero-print-bordero-module","pages-print-pallets-label-print-pallets-label-module":"pages-print-pallets-label-print-pallets-label-module","polyfills-core-js":"polyfills-core-js","polyfills-css-shim":"polyfills-css-shim","polyfills-dom":"polyfills-dom","shadow-css-a3f00b33-js":"shadow-css-a3f00b33-js","swiper-bundle-44a9b1f9-js":"swiper-bundle-44a9b1f9-js","focus-visible-f4ad4f1a-js":"focus-visible-f4ad4f1a-js","input-shims-73f15161-js":"input-shims-73f15161-js","keyboard-5742b5da-js":"keyboard-5742b5da-js","status-tap-bdecfebf-js":"status-tap-bdecfebf-js","swipe-back-ee838cf8-js":"swipe-back-ee838cf8-js","tap-click-cc1ae2b2-js":"tap-click-cc1ae2b2-js","pages-admins-pages-warehouse-form-warehouse-form-module":"pages-admins-pages-warehouse-form-warehouse-form-module","pages-couriers-pages-edit-empty-pallets-edit-empty-pallets-module":"pages-couriers-pages-edit-empty-pallets-edit-empty-pallets-module","pages-warehouse-pages-pallet-history-pallet-history-module":"pages-warehouse-pages-pallet-history-pallet-history-module","pages-warehouse-pages-warehouse-status-warehouse-status-module":"pages-warehouse-pages-warehouse-status-warehouse-status-module","default~pages-admins-pages-user-form-user-form-module~pages-couriers-pages-validate-delivery-validat~3602c380":"default~pages-admins-pages-user-form-user-form-module~pages-couriers-pages-validate-delivery-validat~3602c380","pages-admins-pages-user-form-user-form-module":"pages-admins-pages-user-form-user-form-module","default~pages-admins-pages-users-users-module~pages-admins-pages-warehouses-list-warehouses-list-mod~517a345f":"default~pages-admins-pages-users-users-module~pages-admins-pages-warehouses-list-warehouses-list-mod~517a345f","pages-warehouse-pages-quick-delivery-quick-delivery-module":"pages-warehouse-pages-quick-delivery-quick-delivery-module","default~pages-admins-pages-users-users-module~pages-admins-pages-warehouses-list-warehouses-list-mod~79ff0dbd":"default~pages-admins-pages-users-users-module~pages-admins-pages-warehouses-list-warehouses-list-mod~79ff0dbd","default~pages-admins-pages-users-users-module~pages-admins-pages-warehouses-list-warehouses-list-mod~040141e1":"default~pages-admins-pages-users-users-module~pages-admins-pages-warehouses-list-warehouses-list-mod~040141e1","pages-admins-pages-warehouses-list-warehouses-list-module":"pages-admins-pages-warehouses-list-warehouses-list-module","pages-couriers-pages-transshipment-transshipment-module":"pages-couriers-pages-transshipment-transshipment-module","pages-couriers-pages-validate-pallets-validate-pallets-module":"pages-couriers-pages-validate-pallets-validate-pallets-module","pages-warehouse-pages-pallets-list-pallets-list-module":"pages-warehouse-pages-pallets-list-pallets-list-module","default~pages-couriers-pages-deliveries-deliveries-module~pages-couriers-pages-validate-delivery-val~9fb27835":"default~pages-couriers-pages-deliveries-deliveries-module~pages-couriers-pages-validate-delivery-val~9fb27835","pages-couriers-pages-validate-delivery-validate-delivery-module":"pages-couriers-pages-validate-delivery-validate-delivery-module","pages-admins-pages-users-users-module":"pages-admins-pages-users-users-module","pages-warehouse-pages-deliveries-deliveries-module":"pages-warehouse-pages-deliveries-deliveries-module","pages-couriers-pages-pallets-pallets-module":"pages-couriers-pages-pallets-pallets-module","pages-warehouse-pages-delivery-planner-delivery-planner-module":"pages-warehouse-pages-delivery-planner-delivery-planner-module","pages-couriers-pages-deliveries-deliveries-module":"pages-couriers-pages-deliveries-deliveries-module","pages-couriers-pages-deliveries-list-deliveries-list-module":"pages-couriers-pages-deliveries-list-deliveries-list-module","pages-warehouse-pages-home-home-module":"pages-warehouse-pages-home-home-module"}[chunkId]||chunkId) + "." + {"0":"6dfaee16c7d97f39276f","1":"924c850dd2d70d461e9f","2":"5bf5d20753fc136e8fc7","3":"f22b90dfd4fb29e83789","4":"5370a04503a6a38108bf","5":"b37ff6c992be806c231a","6":"6f37721c4a89fc281919","7":"09ae11c79f35b937dede","8":"d4bcae3d764635c397cd","9":"cad349a257e5d1f6d8dd","10":"2c6ec9406c41aaca95e7","11":"4e4470f2dc027d3e30d1","12":"66fe2d4531d6daee91d6","13":"0f1b1f21c2ce2591832b","14":"6e12b2875b59c02f9e2c","15":"19168d9f4cdafd800946","16":"ac7101ac0422aba01390","17":"6a0ea7e62772b1152103","18":"7ca767a05f3d20a8f11e","19":"b36382ef0b453c46c372","20":"502ec5b78d09dca800fc","21":"1ba0aa251f1274746f3b","22":"7774dd5aa28b08c305bd","23":"dfa11b0121e54b4b8a86","24":"40c51dc59670985bdd52","25":"0aa011f0353a9846e320","26":"c9f7eee868ef2f98e3f1","27":"8a55f3b6db385fa1d803","28":"a442b37d7fd03052b644","29":"926d0acabae8118858c6","30":"a9781421a972c9184d2b","31":"60246d2c51d216165205","32":"12d6f96774cf9ae33d31","33":"b75d28f75b3b7bd055b7","34":"42c73543fbaf75ab7b1e","35":"2a2e1ad1047ee24a953e","36":"86920ab893e8f2374cfe","37":"cfbf92e4881744bae187","38":"65813f9cda8c208b4908","39":"6f3df3b8ae5920863a1d","40":"270aecb6cd31d3e286a9","41":"8bfc499465b393a7600b","42":"21f9d6e878a6ea5b76e7","common":"c2cbe20a71ab79a82017","default~dashboard-dashboard-module~home-home-module~pages-print-bordero-print-bordero-module":"6f70d52732c37395c114","dashboard-dashboard-module":"934cef5325895d6adcde","home-home-module":"d7be1bfd07589e82119b","default~pages-couriers-pages-deliveries-deliveries-module~pages-couriers-pages-validate-delivery-val~e6285bd4":"8a7654da0502152c16bb","pages-print-bordero-print-bordero-module":"58acb7ce5bda4af4e47f","pages-print-pallets-label-print-pallets-label-module":"9cd50efba282e51c366d","polyfills-core-js":"c3fbb0eaa8e56c74252c","polyfills-css-shim":"a5b76f9363dbe3f69e33","polyfills-dom":"7d25808952944aec6b00","shadow-css-a3f00b33-js":"9696368761c20c566b78","swiper-bundle-44a9b1f9-js":"720e9c397d38d6f83a77","focus-visible-f4ad4f1a-js":"7cc90bb313636f58ad6d","input-shims-73f15161-js":"8bcb5a16b7fc7325aec9","keyboard-5742b5da-js":"c0817486320b9fd6fa84","status-tap-bdecfebf-js":"34308c03097305cd891b","swipe-back-ee838cf8-js":"7a626ad640a3cdfbfe15","tap-click-cc1ae2b2-js":"421b984960b584667553","pages-admins-pages-warehouse-form-warehouse-form-module":"9ccdbb749d54af8d5153","pages-couriers-pages-edit-empty-pallets-edit-empty-pallets-module":"b917c009cb267612285e","pages-warehouse-pages-pallet-history-pallet-history-module":"550db142176e38faba08","pages-warehouse-pages-warehouse-status-warehouse-status-module":"c5da42dd183f470f7d2f","default~pages-admins-pages-user-form-user-form-module~pages-couriers-pages-validate-delivery-validat~3602c380":"59e82dfdbdb4528a551b","pages-admins-pages-user-form-user-form-module":"dbf60d0c4552ad64dabf","default~pages-admins-pages-users-users-module~pages-admins-pages-warehouses-list-warehouses-list-mod~517a345f":"d1b6c7f06b06347c7c8d","pages-warehouse-pages-quick-delivery-quick-delivery-module":"82d9f34b643c58f92e5f","default~pages-admins-pages-users-users-module~pages-admins-pages-warehouses-list-warehouses-list-mod~79ff0dbd":"0e1b88466492e1e5b546","default~pages-admins-pages-users-users-module~pages-admins-pages-warehouses-list-warehouses-list-mod~040141e1":"34caeace70ce2d032faf","pages-admins-pages-warehouses-list-warehouses-list-module":"cbecc5b3d552ca5d1086","pages-couriers-pages-transshipment-transshipment-module":"cd813c0eb13fd805a61c","pages-couriers-pages-validate-pallets-validate-pallets-module":"60110410a6553a6e6e44","pages-warehouse-pages-pallets-list-pallets-list-module":"42d4b4c3444e2a787279","default~pages-couriers-pages-deliveries-deliveries-module~pages-couriers-pages-validate-delivery-val~9fb27835":"8e1046d069108fea10e5","pages-couriers-pages-validate-delivery-validate-delivery-module":"b3e26fd5610904ecab45","pages-admins-pages-users-users-module":"9f91a9458b67b52ca385","pages-warehouse-pages-deliveries-deliveries-module":"f7070ae16df49f8b658c","pages-couriers-pages-pallets-pallets-module":"6f9d28bc5c03e3e391fe","pages-warehouse-pages-delivery-planner-delivery-planner-module":"a191e9d867a9b6e86763","pages-couriers-pages-deliveries-deliveries-module":"fac2fb01b356c2b35478","pages-couriers-pages-deliveries-list-deliveries-list-module":"40086935bf924c722300","pages-warehouse-pages-home-home-module":"7d41ecde17681eb664af"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
